<template>
    <v-container fluid>
        <v-card>
            
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Branch Sales Report</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/sales-summary">
                    <v-icon left>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <div>
                    <v-row dense>
                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <!-- datepicker 2 -->
                        <v-col cols="12" xs="12" md="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                                        prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                                </template>
                                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete name="salesReportProductID" dense outlined v-model="record.ProductId"
                                :items="products" label="Products" item-text="Name" item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete name="salesTransactionsCustomer" dense outlined v-model="record.CustomerId"
                                :items="customers" label="Customer" item-text="Name" item-value="id"
                                @change="getBranches(record.CustomerId)"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="6">
                            <v-autocomplete class="mt-1" autocomplete="off" dense outlined v-model="record.StoreId"
                                :items="branches" label="Select Branch" item-text="Name"
                                item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" xs="12" md="3">
                            <v-autocomplete class="mt-1" autocomplete="off" dense outlined v-model="record.SalesRep"
                                :items="users" label="Sales Rep" item-text="name" item-value="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="6" xs="6" md="3">
                            <v-btn :loading="loader" @click="getReport" color="primary"><v-icon
                                    left>mdi-list-box-outline</v-icon>Generate
                                Report</v-btn>
                        </v-col>

                        <v-col cols="6" xs="6" md="6" v-show="totalSales">
                            <span class="style-18">Total Sales: {{ totalSales | currency }}</span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" xs="12" md="4">
                            <span class="totals" v-show="role == 3 || role == 2">Total Sales: {{ totalSales }}</span>
                            <br />
                            <span v-if="TotalReturns" style="color: red">Total Returns: {{ TotalReturns.toLocaleString()
                                }}</span>
                        </v-col>
                    </v-row>

                    <v-row dense class="subtitle-2 text--primary">
                        <v-col cols="12">
                            <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
                            <!-- start of table -->
                            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers"
                                :items="soldProducts" :search="search">
                                <!-- template -->
                                <template v-slot:item.Price="{ item }">
                                    {{
                                        item.Price.toLocaleString()
                                    }}
                                </template>
                                <!-- end -->


                                <!-- template -->
                                <!-- <template v-slot:item.PaymentModes="{ item }">
                 <div v-for="(value, index) in item.document.rct1" v-bind:key="index">
                  {{ value.oact.Name }}  {{ value.SumApplied.toLocaleString() }}  ref: {{ value.PaymentRemarks }}
                 </div>
                </template> -->
                                <!-- end -->

                                <!-- action template -->
                                <template v-slot:item.DocNum="{ item }">
                                    <v-btn color="accent" text :to="`/pos/sale-details/${item.InvoiceId}`">{{
                                        item.DocNum }}</v-btn>
                                </template>
                                <!-- end -->

                                <!-- template -->
                                <template v-slot:item.LineTotal="{ item }">
                                    {{
                                        item.LineTotal | currency
                                    }}
                                </template>
                                <!-- end -->

                                <!-- date template -->
                                <template v-slot:item.Date="{ item }">
                                    {{
                                        item.Date | date
                                    }}
                                </template>
                                <!-- end -->

                            </v-data-table>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            record: {},
            pageItems: 500,
            IMEI: null,
            menu1: false,
            menu2: false,
            search: null,
            loader: false,
            zeroValue: 0,
            products: [],
            customers: [],
            reportData: {},
            outsourcedData: [],
            TotalProfit: null,
            TotalQuantitySold: null,
            users: [],
            brands: [],
            branches: [],
            categories: [],
            drivers: [],
            headers: [
                { text: "Invoice No.", value: "DocNum" },
                { text: "Product", value: "ProductName" },
                { text: "Qty", value: "Quantity" },
                { text: "UOM", value: "UomName" },
                { text: "Price", value: "Price" },
                { text: "Total", value: "LineTotal" },
                { text: "Customer", value: "CustomerName" },
                { text: "Payment Mode", value: "PaymentModes" },
                { text: "Owner", value: "OwnerName" },
                { text: "Sold By", value: "SoldBy" },
                { text: "Date", value: "Date" }
            ],
            outsourcedHeaders: [
                { text: "Invoice No.", value: "DocNum" },
                { text: "Item Name", value: "Name" },
                { text: "Quantity", value: "Quantity" },
                { text: "Unit", value: "UomName" },
                { text: "SellingPrice", value: "Price" },
                { text: "Total", value: "LineTotal" },
                { text: "Customer", value: "invoice.Customer.Name" },
                { text: "Date", value: "Date" }
            ],
            fields: {
                Product: "product.Name",
                Quantity: "Quantity",
                Price: "Price",
                Total: "LineTotal",
                Date: "DocDate",
                Customer: "document.ocrd.Name",
            },
            soldProducts: [],
            totalSales: null,
            returnsData: [],
            TotalReturns: null
        };
    },
    computed: {
        storeName() {
            return localStorage.getItem("storeName");
        },
        userId() {
            return localStorage.getItem("userId");
        },
        activeStore() {
            return localStorage.getItem("store_id");
        },
        role() {
            return localStorage.getItem("userRole");
        },
    },
    methods: {
        setStartDate(date) {
            this.record.StartDate = date;
        },
        setEndDate(date) {
            this.record.EndDate = date;
        },
        getProducts() {
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("get", `/products`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.products = res.ResponseData;
                        self.loader = false;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getReport() {
            const data = this.record;
            const url = "/branch-sales-report";
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.SalesReportData = res.ResponseData;
                        self.soldProducts = res.ResponseData.SoldProducts;
                        self.totalSales = res.ResponseData.TotalSales;
                        self.outsourcedData = res.ResponseData.OutsourcedSales;
                        self.$store.commit("loader", false);
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                    self.loader = false;
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getCategories() {
            const self = this;
            this.$store
                .dispatch("get", `/products-categories`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.categories = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        printDoc() {
            if (this.record.StartDate == null || this.record.EndDate == null) {
                this.$refs.snackbar.show("Please select both dates", "red");
            } else {
                this.print();
            }
        },
        print() { },
        getCustomers() {
            const self = this;
            this.$store
                .dispatch("get", `/customers`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.customers = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getGenSettings() {
            const self = this;
            this.$store
                .dispatch("get", `/general-settings`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.IMEI = res.ResponseData.IMEI;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getBranches(id) {
            const self = this;
            var url = `/stores/customers/${id}`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.branches = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getUsers() {
            const self = this;
            var url = `/users`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.users = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([
            this.getCustomers(),
            this.getCategories(),
            this.getGenSettings(),
            this.getProducts(),
            this.getUsers(),
        ]);
    },
};
</script>

<style lang="scss" scoped></style>